import { BOB_ARCADE } from '../../../packages/domain/src/91-bob-arcade.mjs';

/** HUD projection of domain-owned chain state. The meter uses active simulation
 * milliseconds, so pause cannot spend its window. It awards no points and owns
 * no timer or animation frame. Frequent pickups do not flood the live region. */
export function createBobArcadeHud(ctx, stage) {
  const root = ctx.e('div', 'bob-arcade');
  const title = ctx.e('span', 'bob-chain-title', 'BUILD A CHAIN');
  const count = ctx.e('strong', 'bob-chain-count', '×1');
  const detail = ctx.e('span', 'bob-chain-detail', 'Collect · bounce · explore');
  const meter = ctx.e('progress', 'bob-chain-meter');
  meter.max = BOB_ARCADE.windowMs;
  meter.setAttribute('aria-label', 'Time remaining to continue your chain');
  root.setAttribute('aria-label', 'Arcade chain');
  root.append(title, count, detail, meter);
  stage.append(root);
  return {
    paint(state, playing) {
      const chain = state.arcade;
      const active = chain?.chain > 0 && chain.expiresAt > state.elapsed;
      root.hidden = !playing;
      root.dataset.active = String(active);
      root.dataset.fever = String(active && chain.multiplier >= BOB_ARCADE.maxMultiplier);
      title.textContent = active ? `${chain.chain} HIT CHAIN` : 'BUILD A CHAIN';
      count.textContent = `×${active ? chain.multiplier : 1}`;
      detail.textContent = active
        ? `${chain.bestChain} best · keep it flowing!`
        : 'Collect · bounce · explore';
      meter.value = active ? Math.max(0, chain.expiresAt - state.elapsed) : 0;
      meter.setAttribute(
        'aria-valuetext',
        active
          ? `${Math.ceil(meter.value / 1000)} seconds to continue your ${chain.chain} action chain`
          : 'Collect goodies or time a bounce to start a chain',
      );
    },
    event(event) {
      if (event.type === 'arcade') root.dataset.beat = String(event.id % 2);
    },
  };
}
